import { useState, useEffect } from "react"
import { useFirestore } from "../../hooks/useFirestore"

export const TransactionForm = ({ uid }) => {

    const [name, setName] = useState('')
    const [amount, setAmount] = useState('')
    const { addDocument, response } = useFirestore('transactions')

    const handleSubmit = (e) => {
        e.preventDefault()
        addDocument({
            uid,
            name,
            amount
        })
        
    }
    // reset the form field.
    useEffect(() => {
      
    if(response.success) {
        setName('')
        setAmount('')
    }
     
    }, [response.success])
    


  return (
    <div className="my-5 ">
        <h3 className="font-bold text-sm mb-2">Add a Expense</h3>
        <form onSubmit={handleSubmit}>
            <input 
            type='text'
            placeholder="name"
            required
            onChange={(e) => setName(e.target.value)}
            value={name } 
            className="rounded-md border-2 p-2 mr-4 focus:border-sky-500"
            />
             <input 
            type='text'
            placeholder="amount"
            required
            onChange={(e) => setAmount(e.target.value)}
            value={amount } 
            className="rounded-md border-2 p-2 mr-4 focus:border-sky-500"
            />
            <button 
                className="inline-flex items-center py-2 px-4 border border-transparent rounded-md shadow-sm text-md font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                type="submit"
            >Add Expense</button>
        </form>
    </div>
  )
}
